import React from 'react';
import { ImageStyle, StyleSheet } from 'react-native';
import styled from 'styled-components/native';

import Image from '@src/components/Image';
import { avatarSize } from '@src/configuration/constants';
import { Source } from '@src/types';

type Props = {
  size?: number;
  source?: Source;
  style?: ImageStyle;
};

const Content = styled(Image)<Props>`
  width: ${({ size = avatarSize }) => size}px;
  height: ${({ size = avatarSize }) => size}px;
  border-radius: ${({ size = avatarSize }) => size / 2}px;
  background-color: ${({ theme }) => theme.colors.placeholder};
  border-color: ${({ theme }) => theme.colors.disabled};
  border-width: 1px;
`;

const Component: React.FC<Props> = ({ size, source, style }) => (
  <Content
    source={source ?? require('@src/assets/images/avatar.png')}
    size={size}
    style={style}
  />
);

Component.displayName = 'Avatar';

export default React.memo(Component);
